import defaultCursorUrl from "@/assets/images/default.svg?url";
import pointerCursorUrl from "@/assets/images/pointer.svg?url";

const STYLE_ID = "mana-cursor-styles";

export function applyManaCursors() {
  if (document.getElementById(STYLE_ID)) return;

  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = `
    html,
    body,
    #root,
    [role="dialog"] {
      cursor: url("${defaultCursorUrl}") 6 4, default;
    }

    canvas.mana-scene-canvas {
      cursor: url("${defaultCursorUrl}") 6 4, default;
    }

    a[href],
    button:not(:disabled),
    [role="button"]:not([aria-disabled="true"]),
    [role="tab"]:not([aria-disabled="true"]),
    [role="link"],
    label[for],
    select,
    summary,
    input[type="button"]:not(:disabled),
    input[type="submit"]:not(:disabled),
    input[type="reset"]:not(:disabled),
    input[type="checkbox"],
    input[type="radio"],
    .cursor-mana-pointer {
      cursor: url("${pointerCursorUrl}") 11 5, pointer;
    }

    button:disabled,
    [aria-disabled="true"] {
      cursor: url("${defaultCursorUrl}") 6 4, default;
    }

    .cursor-mana-default {
      cursor: url("${defaultCursorUrl}") 6 4, default;
    }

    .cursor-mana-pointer {
      cursor: url("${pointerCursorUrl}") 11 5, pointer;
    }
  `;

  document.head.appendChild(style);
}
